import { formatSplitPercentage } from "./salesPersonSplitUtils";

const SELLING_TYPE_ID = 1;
const SOURCING_TYPE_ID = 2;

const MATCH_CRITERIA = {
  offer:
    "Offer: an open offer (offer status Pending or To Be Invoiced) by the invoice client, in the invoice currency, either held on this work or made on its artwork without a hold. The work's own status does not matter. Held offers come first, then To Be Invoiced, then the newest. It is the same offer that sets the amount.",
  consignment:
    "Consignment: the newest Consignment or Purchase containing this work. It is the same consignment that sets the consignor split.",
  split: "Selling and sourcing each get 50% of the invoice split.",
};

const describePeople = salesPeople =>
  salesPeople
    .map(
      salesPerson =>
        `${salesPerson?.salesUser?.name || `User ${salesPerson?.salesUserId}`} ${formatSplitPercentage(salesPerson?.split)}`,
    )
    .join(", ");

const describeSection = ({ label, sourceLabel, source, salesPeople }) => {
  if (!source) return `${label}: no matching ${sourceLabel.toLowerCase()}.`;
  if (!salesPeople.length) {
    return `${label}: ${sourceLabel} #${source.id} has no ${label.toLowerCase()} people.`;
  }
  return `${label} from ${sourceLabel} #${source.id}: ${describePeople(salesPeople)}.`;
};

// Turns the matchedSalesPeople returned for a sale line into the lines shown
// in the Add Transaction modal.
const summariseMatchedSalesPeople = (matchedSalesPeople, { canEdit } = {}) => {
  const {
    offer,
    consignment,
    invoiceHasSalesPeople,
    salesPeople = [],
  } = matchedSalesPeople || {};

  if (!offer && !consignment) return null;

  const sellingPeople = salesPeople.filter(
    salesPerson => salesPerson?.typeId === SELLING_TYPE_ID,
  );
  const sourcingPeople = salesPeople.filter(
    salesPerson => salesPerson?.typeId === SOURCING_TYPE_ID,
  );
  const hasPeople = salesPeople.length > 0;

  const status = !hasPeople
    ? { tone: "info", message: "There are no sales people to add." }
    : invoiceHasSalesPeople
      ? {
          tone: "warning",
          message:
            "This invoice already has sales people, so these will not be added automatically.",
        }
      : !canEdit
        ? {
            tone: "warning",
            message:
              "You do not have permission to edit sales people, so these will not be added.",
          }
        : {
            tone: "info",
            message:
              "These will be added to the invoice's sales people when you create the transaction.",
          };

  return {
    sections: [
      describeSection({
        label: "Selling",
        sourceLabel: "Offer",
        source: offer,
        salesPeople: sellingPeople,
      }),
      describeSection({
        label: "Sourcing",
        sourceLabel: "Consignment",
        source: consignment,
        salesPeople: sourcingPeople,
      }),
    ],
    criteria: [
      MATCH_CRITERIA.offer,
      MATCH_CRITERIA.consignment,
      MATCH_CRITERIA.split,
    ],
    status,
    canAddToExisting: hasPeople && invoiceHasSalesPeople && canEdit,
  };
};

export { summariseMatchedSalesPeople };
